import React, { useState } from "react";
import {
  createChart,
  CandlestickSeries,
  LineSeries,
  createSeriesMarkers,
  AreaSeries,
  HistogramSeries,
  CrosshairMode,
} from "lightweight-charts";
import { useEffect, useRef, useCallback } from "react";
import "./CandleChart.css";
import { useChartIndicator } from "../../context/ChartIndicatorContext";

//commenyed cpde whole
// const convertCloseSeriesToIntraday = (closeSeries) => {
//   return {
//     open: closeSeries.map((d) => d.close),
//     high: closeSeries.map((d) => d.close),
//     low: closeSeries.map((d) => d.close),
//     close: closeSeries.map((d) => d.close),
//     volume: closeSeries.map(() => 0),

//     // 🔥 THIS IS IMPORTANT
//     timestamp: closeSeries.map((d) => d.date),
//   };
// };

// const parseTime = (str) => {
//   if (!str) return null;

//   const [datePart, timePartRaw] = str.split(",");

//   const [day, month, year] = datePart.trim().split("/").map(Number);

//   let [timePart, ampm] = timePartRaw.trim().split(" ");
//   let [hours, minutes, seconds] = timePart.split(":").map(Number);

//   // convert to 24-hour
//   if (ampm.toLowerCase() === "pm" && hours !== 12) hours += 12;
//   if (ampm.toLowerCase() === "am" && hours === 12) hours = 0;

//   // 🔥 IMPORTANT: use UTC
//   const utcTime = Date.UTC(year, month - 1, day, hours, minutes, seconds);

//   return Math.floor(utcTime / 1000);
// };

// //previous working
// // const parseChartTime = (t, index = 0) => {
// //   // already unix
// //   if (typeof t === "number") return t;

// //   if (typeof t === "string") {
// //     // 🔥 Intraday
// //     if (t.includes(",")) {
// //       return Math.floor(new Date(t).getTime() / 1000);
// //     }

// //     // 🔥 Day
// //     if (t.includes("-")) {
// //       return Math.floor(new Date(t).getTime() / 1000);
// //     }
// //   }

// //   return Math.floor(Date.now() / 1000) + index;
// // };

// // const parseChartTime = (t, mode, index = 0) => {
// //   if (!t) {
// //     return Math.floor(Date.now() / 1000) + index;
// //   }

// //   // ✅ already unix
// //   if (typeof t === "number") {
// //     return t > 9999999999 ? Math.floor(t / 1000) : t;
// //   }

// //   // ✅ MIN MODE
// //   if (mode === "min") {
// //     const parsed = new Date(t);

// //     if (!isNaN(parsed.getTime())) {
// //       return Math.floor(parsed.getTime() / 1000);
// //     }
// //   }

// //   // ✅ DAY MODE
// //   if (mode === "day") {
// //     const parsed = new Date(`${t}T00:00:00`);

// //     if (!isNaN(parsed.getTime())) {
// //       return Math.floor(parsed.getTime() / 1000);
// //     }
// //   }

// //   return Math.floor(Date.now() / 1000) + index;
// // };
// // const parseChartTime = (t, mode, index = 0) => {
// //   if (!t) {
// //     return Math.floor(Date.now() / 1000) + index;
// //   }

// //   // UNIX
// //   if (typeof t === "number") {
// //     return t > 9999999999 ? Math.floor(t / 1000) : t;
// //   }

// //   // MIN MODE
// //   if (mode === "min") {
// //     const [datePart, timePartRaw] = t.split(",");

// //     const [day, month, year] = datePart.trim().split("/").map(Number);

// //     let [timePart, ampm] = timePartRaw.trim().split(" ");

// //     let [hour, minute, second] = timePart.split(":").map(Number);

// //     if (ampm.toLowerCase() === "pm" && hour !== 12) {
// //       hour += 12;
// //     }

// //     if (ampm.toLowerCase() === "am" && hour === 12) {
// //       hour = 0;
// //     }

// //     return Math.floor(
// //       new Date(year, month - 1, day, hour, minute, second).getTime() / 1000,
// //     );
// //   }

// //   // DAY MODE
// //   if (mode === "day") {
// //     return Math.floor(new Date(`${t}T00:00:00`).getTime() / 1000);
// //   }

// //   return Math.floor(Date.now() / 1000) + index;
// // };

// //previous working code
// // const parseChartTime = (t, mode, index = 0) => {
// //   if (!t) {
// //     return mode === "day"
// //       ? "1970-01-01"
// //       : Math.floor(Date.now() / 1000) + index;
// //   }

// //   // ✅ Already UNIX
// //   if (typeof t === "number") {
// //     return t > 9999999999 ? Math.floor(t / 1000) : t;
// //   }

// //   // =========================
// //   // 🔥 INTRADAY
// //   // =========================
// //   if (mode === "min") {
// //     const d = new Date(t);

// //     if (isNaN(d.getTime())) {
// //       return Math.floor(Date.now() / 1000) + index;
// //     }

// //     return Math.floor(d.getTime() / 1000);
// //   }

// //   // =========================
// //   // 🔥 DAILY
// //   // =========================
// //   if (mode === "day") {
// //     // ✅ KEEP STRING
// //     return t;
// //   }

// //   return Math.floor(Date.now() / 1000) + index;
// // };

// const parseChartTime = (t, mode) => {
//   if (!t) {
//     return mode === "day" ? "2026-01-01" : Math.floor(Date.now() / 1000);
//   }

//   /* =========================
//      DAY MODE
//   ========================= */

//   if (mode === "day") {
//     // already yyyy-mm-dd
//     if (typeof t === "string" && t.includes("-")) {
//       return t.split("T")[0];
//     }

//     // unix timestamp → convert to yyyy-mm-dd
//     if (typeof t === "number") {
//       return new Date(t * 1000).toISOString().split("T")[0];
//     }

//     return new Date(t).toISOString().split("T")[0];
//   }

//   /* =========================
//      INTRADAY MODE
//   ========================= */

//   // already unix
//   if (typeof t === "number") {
//     return t > 9999999999 ? Math.floor(t / 1000) : t;
//   }

//   const parsed = new Date(t).getTime();

//   if (isNaN(parsed)) {
//     return Math.floor(Date.now() / 1000);
//   }

//   return Math.floor(parsed / 1000);
// };

// //new utbot
// const prepareCandleData = (data, mode) => {
//   const { open = [], high = [], low = [], close = [], timestamp = [] } = data;

//   return timestamp.map((t, i) => ({
//     // time: parseChartTime(t, mode, i),
//     time: mode === "day" ? timestamp[i] : parseChartTime(timestamp[i], mode, i),
//     // time:
//     //   mode === "min"
//     //     ? Number(data.timestamp[i]) // ✅ intraday UNIX timestamp
//     //     : data.timestamp[i], // daily can stay string/date
//     open: open[i],
//     high: high[i],
//     low: low[i],
//     close: close[i],
//   }));
// };

// const calculateUTBotWithSignals = (candles, key = 3, atrPeriod = 10) => {
//   if (!candles || candles.length < 2) {
//     return { ut: [], signals: [] };
//   }

//   // =========================
//   // 🔹 TRUE RANGE
//   // =========================
//   const tr = [];

//   for (let i = 1; i < candles.length; i++) {
//     const high = candles[i].high;
//     const low = candles[i].low;
//     const prevClose = candles[i - 1].close;

//     tr.push(
//       Math.max(
//         high - low,
//         Math.abs(high - prevClose),
//         Math.abs(low - prevClose),
//       ),
//     );
//   }

//   // =========================
//   // 🔹 ATR (Wilder RMA)
//   // =========================
//   const atr = [];

//   for (let i = 0; i < tr.length; i++) {
//     if (i === 0) {
//       atr.push(tr[0]);
//     } else {
//       atr.push((atr[i - 1] * (atrPeriod - 1) + tr[i]) / atrPeriod);
//     }
//   }

//   // align with candles
//   atr.unshift(atr[0]);

//   // =========================
//   // 🔹 UT BOT
//   // =========================
//   const ut = [];
//   const signals = [];

//   let prevStop = candles[0].close;
//   let lastSignal = null;

//   const nz = (v, d = 0) => (v === undefined || v === null ? d : v);

//   for (let i = 0; i < candles.length; i++) {
//     const src = candles[i].close;

//     const prevSrc = i > 0 ? candles[i - 1].close : src;

//     const nLoss = key * (atr[i] || 0);

//     let stop;

//     // =========================
//     // 🔹 Trailing Stop Logic
//     // =========================
//     if (i === 0) {
//       stop = src;
//     } else {
//       const prevStopNz = nz(prevStop);

//       // bullish continuation
//       if (src > prevStopNz && prevSrc > prevStopNz) {
//         stop = Math.max(prevStopNz, src - nLoss);
//       }

//       // bearish continuation
//       else if (src < prevStopNz && prevSrc < prevStopNz) {
//         stop = Math.min(prevStopNz, src + nLoss);
//       }

//       // bullish reversal
//       else if (src > prevStopNz) {
//         stop = src - nLoss;
//       }

//       // bearish reversal
//       else {
//         stop = src + nLoss;
//       }
//     }

//     // =========================
//     // 🔹 BUY / SELL SIGNALS
//     // =========================
//     if (i > 0) {
//       const prevStopNz = nz(prevStop);

//       // ✅ BUY crossover
//       const isBuy = prevSrc <= prevStopNz && src > prevStopNz;

//       // ✅ SELL crossunder
//       const isSell = prevSrc >= prevStopNz && src < prevStopNz;

//       // ✅ BUY signal
//       if (isBuy && lastSignal !== "BUY") {
//         signals.push({
//           time: candles[i].time,
//           position: "belowBar",
//           color: "#00ff00",
//           shape: "arrowUp",
//           text: "BUY",
//         });

//         lastSignal = "BUY";
//       }

//       // ✅ SELL signal
//       if (isSell && lastSignal !== "SELL") {
//         signals.push({
//           time: candles[i].time,
//           position: "aboveBar",
//           color: "#ff0000",
//           shape: "arrowDown",
//           text: "SELL",
//         });

//         lastSignal = "SELL";
//       }
//     }

//     // =========================
//     // 🔹 UT LINE
//     // =========================
//     ut.push({
//       time: candles[i].time,
//       value: stop,
//     });

//     prevStop = stop;
//   }

//   return {
//     ut,
//     signals,
//   };
// };

// const generateSignals = (candles, vwapData) => {
//   const signals = [];

//   for (let i = 1; i < candles.length; i++) {
//     const prevClose = candles[i - 1].close;
//     const currClose = candles[i].close;

//     const prevVWAP = vwapData[i - 1]?.value;
//     const currVWAP = vwapData[i]?.value;

//     if (!prevVWAP || !currVWAP) continue;

//     // 🟢 BUY → reclaim above VWAP
//     if (prevClose < prevVWAP && currClose > currVWAP) {
//       signals.push({
//         time: candles[i].time,
//         position: "belowBar",
//         color: "green",
//         shape: "arrowUp",
//         text: "BUY",
//       });
//     }

//     // 🔴 SELL → breakdown below VWAP
//     if (prevClose > prevVWAP && currClose < currVWAP) {
//       signals.push({
//         time: candles[i].time,
//         position: "aboveBar",
//         color: "red",
//         shape: "arrowDown",
//         text: "SELL",
//       });
//     }
//   }

//   return signals;
// };

// const calculateVWAP = (intraday = {}, mode, source = "hlc3") => {
//   // ✅ fallback object
//   const {
//     high = [],
//     low = [],
//     close = [],
//     volume = [],
//     timestamp = [],
//   } = intraday || {};

//   // ✅ no data yet
//   if (!timestamp.length || !close.length) {
//     return [];
//   }

//   let cumulativePV = 0;
//   let cumulativeVolume = 0;

//   return timestamp.map((time, i) => {
//     let price = 0;

//     switch (source) {
//       case "low":
//         price = Number(low[i]) || 0;
//         break;

//       case "high":
//         price = Number(high[i]) || 0;
//         break;

//       case "close":
//         price = Number(close[i]) || 0;
//         break;

//       case "hlc3":
//       default:
//         price =
//           ((Number(high[i]) || 0) +
//             (Number(low[i]) || 0) +
//             (Number(close[i]) || 0)) /
//           3;
//     }

//     const vol = Number(volume[i]) || 0;

//     cumulativePV += price * vol;

//     cumulativeVolume += vol;

//     return {
//       time: parseChartTime(time, mode, i),

//       value: cumulativeVolume > 0 ? cumulativePV / cumulativeVolume : null,
//     };
//   });
// };

// const prepareHeikinAshiData = (intraday, mode) => {
//   const {
//     open = [],
//     high = [],
//     low = [],
//     close = [],
//     timestamp = [],
//   } = intraday;

//   const haData = [];

//   let prevHAOpen = open[0];
//   let prevHAClose = (open[0] + high[0] + low[0] + close[0]) / 4;

//   for (let i = 0; i < timestamp.length; i++) {
//     const haClose = (open[i] + high[i] + low[i] + close[i]) / 4;
//     const haOpen = (prevHAOpen + prevHAClose) / 2;

//     const haHigh = Math.max(high[i], haOpen, haClose);
//     const haLow = Math.min(low[i], haOpen, haClose);

//     haData.push({
//       // time: parseChartTime(timestamp[i], i),
//       time: parseChartTime(timestamp[i], mode, i),
//       open: haOpen,
//       high: haHigh,
//       low: haLow,
//       close: haClose,
//     });

//     prevHAOpen = haOpen;
//     prevHAClose = haClose;
//   }

//   return haData;
// };

// const normalizeSeriesTime = (arr = [], mode, candleTimes = null) => {
//   const seen = new Set();

//   const parsed = arr
//     .map((item) => ({
//       ...item,

//       time: parseChartTime(item.time, mode),
//     }))

//     // ✅ remove duplicate timestamps
//     .filter((item) => {
//       const key = String(item.time);

//       if (seen.has(key)) {
//         return false;
//       }

//       seen.add(key);

//       return true;
//     })

//     // ✅ sort ascending
//     .sort((a, b) => {
//       if (mode === "day") {
//         return new Date(a.time).getTime() - new Date(b.time).getTime();
//       }

//       return Number(a.time) - Number(b.time);
//     });

//   // intraday alignment
//   if (mode !== "day" && candleTimes) {
//     return parsed.filter((item) => candleTimes.has(Number(item.time)));
//   }

//   return parsed;
// };
// const CandleChart = ({
//   intradayData,
//   histData,
//   setLastUTSignal,
//   width,
//   macdData,
//   chartIndicatorData,
//   isMaximized,
// }) => {
//   // const { chartIndicatorData, getChartIndicators } = useChartIndicator();
//   const [hoverTime, setHoverTime] = useState("");
//   console.log("Intraday data eceived", intradayData);
//   console.log("Historical Data", histData);
//   const intraday = intradayData?.intraday;
//   const bbaweData = chartIndicatorData?.bbawe;
//   const lastBBAWESignal = chartIndicatorData?.lastSignal;
//   const chartRef = useRef();
//   const chartInstance = useRef(null);
//   const candleSeriesRef = useRef(null);
//   const vwapSeriesRef = useRef(null);
//   const utSeriesRef = useRef(null);
//   const bbUpperRef = useRef(null);
//   const tooltipRef = useRef(null);

//   const bbMiddleRef = useRef(null);
//   const containerRef = useRef(null);

//   const bbLowerRef = useRef(null);

//   const bbEMARef = useRef(null);

//   const macdLineRef = useRef(null);

//   const signalLineRef = useRef(null);
//   const [vwapSource, setVwapSource] = useState("hlc3");
//   const [indicator, setIndicator] = useState("vwap");
//   const [timeframe, setTimeframe] = useState("1m");
//   const [mode, setMode] = useState("min"); // min | day

//   const [chartType, setChartType] = useState("normal");

//   const source = mode === "min" ? intradayData?.intraday : histData?.hist;
//   console.log("BBAWE DATA", bbaweData);
//   console.log("CHART INDICATOR DATA", chartIndicatorData);

//   console.log("mode ", mode);
//   useEffect(() => {
//     if (!chartRef.current) return;

//     // chartInstance.current = createChart(chartRef.current, {
//     //   width: chartRef.current.clientWidth,
//     //   height: 400,
//     //   layout: {
//     //     background: { color: "#0f172a" },
//     //     textColor: "#ddd",
//     //   },
//     //   grid: {
//     //     vertLines: { color: "#1e293b" },
//     //     horzLines: { color: "#1e293b" },
//     //   },
//     //   timeScale: {
//     //     timeVisible: true,
//     //     secondsVisible: false,

//     //     // 🔥 ADD THIS
//     //     // tickMarkFormatter: (time) => {
//     //     //   // ONLY apply for DAY mode
//     //     //   if (mode === "day") {
//     //     //     const date = new Date(time * 1000);

//     //     //     return date.toLocaleDateString("en-IN", {
//     //     //       day: "numeric",
//     //     //       month: "short",
//     //     //     }); // 👉 16 Jan
//     //     //   }

//     //     //   // ✅ intraday → keep default behavior
//     //     //   return undefined;
//     //     // },
//     //     // tickMarkFormatter: (time) => {
//     //     //   const date = new Date(time * 1000);

//     //     //   if (mode === "day") {
//     //     //     return date.toLocaleDateString("en-IN", {
//     //     //       day: "numeric",
//     //     //       month: "short",
//     //     //     }); // 16 Jan
//     //     //   }

//     //     //   // intraday
//     //     //   return date.toLocaleTimeString("en-IN", {
//     //     //     hour: "2-digit",
//     //     //     minute: "2-digit",
//     //     //   }); // 09:15
//     //     // },
//     //     // tickMarkFormatter: (time) => {
//     //     //   const date = new Date(time * 1000);

//     //     //   if (mode === "day") {
//     //     //     return date.toLocaleDateString("en-IN", {
//     //     //       day: "numeric",
//     //     //       month: "short",
//     //     //       timeZone: "Asia/Kolkata", // 🔥 FIX
//     //     //     });
//     //     //   }

//     //     //   return date.toLocaleTimeString("en-IN", {
//     //     //     hour: "2-digit",
//     //     //     minute: "2-digit",
//     //     //     hour12: false,
//     //     //     timeZone: "Asia/Kolkata", // 🔥 FIX
//     //     //   });
//     //     // },

//     //     // tickMarkFormatter: (time) => {
//     //     //   const date = new Date(time * 1000);

//     //     //   if (mode === "day") {
//     //     //     return date.toLocaleDateString("en-IN", {
//     //     //       day: "numeric",
//     //     //       month: "short",
//     //     //       timeZone: "Asia/Kolkata",
//     //     //     });

//     //     //   }

//     //     //   return date.toLocaleTimeString("en-IN", {
//     //     //     hour: "2-digit",
//     //     //     minute: "2-digit",
//     //     //     hour12: false,
//     //     //     timeZone: "Asia/Kolkata",
//     //     //   });

//     //     // },
//     //     tickMarkFormatter: (time) => {
//     //       // 🔥 DAILY
//     //       if (mode === "day") {
//     //         const date =
//     //           typeof time === "string" ? new Date(time) : new Date(time * 1000);

//     //         return date.toLocaleDateString("en-IN", {
//     //           day: "numeric",
//     //           month: "short",
//     //           timeZone: "Asia/Kolkata",
//     //         });
//     //       }

//     //       // 🔥 INTRADAY
//     //       const date = new Date(time * 1000);
//     //       console.log("date from ticker", date);

//     //       const formatted = date.toLocaleTimeString("en-IN", {
//     //         hour: "2-digit",
//     //         minute: "2-digit",
//     //         hour12: true,
//     //         timeZone: "Asia/Kolkata",
//     //       });

//     //       console.log("FORMATTED TIME:", formatted);

//     //       return formatted;

//     //       // return date.toLocaleTimeString("en-IN", {
//     //       //   hour: "2-digit",
//     //       //   minute: "2-digit",
//     //       //   hour12: true,
//     //       //   timeZone: "Asia/Kolkata",
//     //       // });
//     //     },
//     //   },
//     // });

//     chartInstance.current = createChart(chartRef.current, {
//       width: chartRef.current.clientWidth,
//       // height: 400,
//       height: chartRef.current.clientHeight || 400,

//       layout: {
//         background: { color: "#0f172a" },
//         textColor: "#ddd",
//       },

//       grid: {
//         vertLines: { color: "#1e293b" },
//         horzLines: { color: "#1e293b" },
//       },

//       /* =========================
//      🔥 ADD THIS
//   ========================= */

//       localization: {
//         timeFormatter: (time) => {
//           // 🔥 DAILY HOVER LABEL
//           if (mode === "day") {
//             return new Date(time).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//             });
//           }

//           // 🔥 INTRADAY HOVER LABEL
//           else {
//             return new Date(Number(time) * 1000).toLocaleString("en-IN", {
//               timeZone: "Asia/Kolkata",

//               day: "numeric",
//               month: "short",

//               hour: "2-digit",
//               minute: "2-digit",

//               hour12: true,
//             });
//           }
//         },
//       },

//       // localization: {
//       //   tickMarkFormatter: (time) => {
//       //     // 🔥 DAY MODE
//       //     if (mode === "day") {
//       //       let date;

//       //       // BusinessDay object
//       //       if (typeof time === "object" && time.year) {
//       //         date = new Date(time.year, time.month - 1, time.day);
//       //       }
//       //       // yyyy-mm-dd string
//       //       else if (typeof time === "string") {
//       //         date = new Date(time);
//       //       }
//       //       // fallback timestamp
//       //       else {
//       //         date = new Date(time * 1000);
//       //       }

//       //       return date.toLocaleDateString("en-IN", {
//       //         day: "numeric",
//       //         month: "short",
//       //       });
//       //     }

//       //     // 🔥 INTRADAY (UNCHANGED)
//       //     const date = new Date(time * 1000);

//       //     return date.toLocaleTimeString("en-IN", {
//       //       hour: "2-digit",
//       //       minute: "2-digit",
//       //       hour12: true,
//       //       timeZone: "Asia/Kolkata",
//       //     });
//       //   },
//       // },
//       /* =========================
//      X AXIS
//   ========================= */

//       timeScale: {
//         timeVisible: true,
//         secondsVisible: false,

//         tickMarkFormatter: (time) => {
//           // 🔥 DAILY
//           if (mode === "day") {
//             return new Date(time).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//             });
//           } else {
//             const date = new Date(time * 1000);

//             return date.toLocaleTimeString("en-IN", {
//               hour: "2-digit",
//               minute: "2-digit",
//               hour12: true,
//               timeZone: "Asia/Kolkata",
//             });
//           }
//         },
//       },
//       // timeScale: {
//       //   timeVisible: mode !== "day",
//       //   secondsVisible: false,

//       //   tickMarkFormatter: (time) => {
//       //     // 🔥 DAILY ONLY
//       //     if (mode === "day") {
//       //       const date =
//       //         typeof time === "string"
//       //           ? new Date(time)
//       //           : new Date(Date.UTC(time.year, time.month - 1, time.day));

//       //       return date.toLocaleDateString("en-IN", {
//       //         day: "numeric",
//       //         month: "short",
//       //         timeZone: "Asia/Kolkata",
//       //       });
//       //     }

//       //     // 🔥 INTRADAY (UNCHANGED)
//       //     const date = new Date(time * 1000);

//       //     return date.toLocaleTimeString("en-IN", {
//       //       hour: "2-digit",
//       //       minute: "2-digit",
//       //       hour12: true,
//       //       timeZone: "Asia/Kolkata",
//       //     });
//       //   },
//       // },
//     });

//     candleSeriesRef.current =
//       chartInstance.current.addSeries(CandlestickSeries);

//     vwapSeriesRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#f59e0b",
//       lineWidth: 2,
//     });

//     utSeriesRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#a855f7",
//       lineWidth: 2,
//     });
//     macdLineRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#3b82f6",
//       lineWidth: 2,

//       priceScaleId: "macd-scale",

//       lastValueVisible: false,
//       priceLineVisible: false,
//     });

//     signalLineRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#ef4444",
//       lineWidth: 2,

//       priceScaleId: "macd-scale",

//       lastValueVisible: false,
//       priceLineVisible: false,
//     });

//     /* =========================
//    BBAWE SERIES
// ========================= */

//     // bbUpperRef.current = chartInstance.current.addSeries(LineSeries, {
//     //   color: "#60a5fa",
//     //   lineWidth: 1,
//     // });
//     bbUpperRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#60a5fa",
//       lineWidth: 1,

//       priceLineVisible: false,
//       lastValueVisible: false,
//     });

//     bbMiddleRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#ef4444",
//       lineWidth: 2,

//       priceLineVisible: false,
//       lastValueVisible: false,
//     });

//     bbLowerRef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#60a5fa",
//       lineWidth: 1,

//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bbEMARef.current = chartInstance.current.addSeries(LineSeries, {
//       color: "#22c55e",
//       lineWidth: 2,

//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     // bbMiddleRef.current = chartInstance.current.addSeries(LineSeries, {
//     //   color: "#ec4899",
//     //   lineWidth: 2,
//     // });

//     // bbLowerRef.current = chartInstance.current.addSeries(LineSeries, {
//     //   color: "#60a5fa",
//     //   lineWidth: 1,
//     // });

//     // bbEMARef.current = chartInstance.current.addSeries(LineSeries, {
//     //   color: "#22c55e",
//     //   lineWidth: 2,
//     // });

//     return () => {
//       chartInstance.current?.remove();
//     };
//   }, [mode]);
//   const formatMACDSeries = (data = [], key) => {
//     return data
//       .filter((d) => d?.[key] !== null && d?.[key] !== undefined)
//       .map((d) => ({
//         time:
//           mode === "day"
//             ? d.date
//             : Math.floor(new Date(d.date).getTime() / 1000),

//         value: Number(d[key]),
//       }));
//   };

//   useEffect(() => {
//     if (!chartInstance.current) return;

//     const crosshairHandler = (param) => {
//       if (!param.time) return;

//       let formattedTime = "";

//       /* =========================
//        DAY MODE
//     ========================= */

//       if (mode === "day") {
//         // BusinessDay object
//         if (typeof param.time === "object" && param.time.year) {
//           formattedTime = new Date(
//             param.time.year,
//             param.time.month - 1,
//             param.time.day,
//           ).toLocaleDateString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           });
//         }

//         // yyyy-mm-dd string
//         else if (typeof param.time === "string") {
//           formattedTime = new Date(param.time).toLocaleDateString("en-IN", {
//             day: "numeric",
//             month: "short",
//             year: "numeric",
//           });
//         }
//       } else {
//         /* =========================
//        INTRADAY MODE
//     ========================= */
//         // 🔥 UTC → IST ONLY FOR DISPLAY
//         // const istDate = new Date((Number(param.time) + 19800) * 1000);
//         const istDate = new Date(Number(param.time) * 1000);

//         formattedTime = istDate.toLocaleString("en-IN", {
//           day: "numeric",
//           month: "short",

//           hour: "2-digit",
//           minute: "2-digit",

//           hour12: true,
//         });
//       }

//       // console.log("HOVER TIME:", formattedTime);

//       // optional
//       // setHoverTime(formattedTime);
//     };

//     chartInstance.current.subscribeCrosshairMove(crosshairHandler);

//     return () => {
//       if (chartInstance.current) {
//         chartInstance.current.unsubscribeCrosshairMove(crosshairHandler);
//       }
//     };
//   }, [mode]);
//   useEffect(() => {
//     // if (!intraday || !candleSeriesRef.current) return;
//     if (!source || !candleSeriesRef.current) return;

//     const updatedData =
//       mode === "min"
//         ? {
//             ...source,

//             // ✅ USE ORIGINAL UNIX TIMESTAMPS
//             timestamp: intraday?.timestamp,
//           }
//         : {
//             ...source,
//             timestamp: histData?.dates,
//           };

//     // 🔥 prepare base data FIRST (fix order)
//     // const normalData = prepareCandleData(updatedIntraday);
//     // const heikinData = prepareHeikinAshiData(updatedIntraday);
//     const normalData = prepareCandleData(updatedData, mode);
//     const cleanedNormalData = normalData
//       .filter(
//         (item, index, self) =>
//           index === self.findIndex((c) => c.time === item.time),
//       )
//       .sort((a, b) => a.time - b.time);
//     const heikinData = prepareHeikinAshiData(updatedData, mode);

//     const baseData = chartType === "heikin" ? heikinData : normalData;

//     // 🔥 timeframe mapping
//     // const interval = timeframe === "1m" ? 1 : timeframe === "3m" ? 3 : 5;
//     let interval = 1;

//     if (mode === "min") {
//       interval =
//         timeframe === "1m"
//           ? 1
//           : timeframe === "3m"
//             ? 3
//             : timeframe === "5m"
//               ? 5
//               : 15; // 🔥 FIXED
//     } else {
//       interval =
//         timeframe === "1d"
//           ? 1
//           : timeframe === "1w"
//             ? 5
//             : timeframe === "1M"
//               ? 20
//               : 60; // 🔥 FIXED
//     }

//     // 🔥 apply aggregation (NEW but safe)
//     // const candleData = aggregateCandles(baseData, interval);
//     const candleData = aggregateCandles(cleanedNormalData, interval);
//     const candleTimes = new Set(candleData.map((c) => Number(c.time)));

//     // 🔥 VWAP still uses original (important)
//     const vwapData = calculateVWAP(updatedData, mode, vwapSource);

//     // 🔥 set candles
//     candleSeriesRef.current.setData(candleData);

//     // 🔥 clear markers
//     createSeriesMarkers(candleSeriesRef.current, []);

//     // 🔥 SWITCH indicator
//     if (indicator === "vwap") {
//       // vwapSeriesRef.current.setData(vwapData);
//       vwapSeriesRef.current.setData(
//         normalizeSeriesTime(vwapData, mode, candleTimes),
//       );
//       utSeriesRef.current.setData([]);
//       bbUpperRef.current.setData([]);

//       bbMiddleRef.current.setData([]);

//       bbLowerRef.current.setData([]);

//       bbEMARef.current.setData([]);

//       const markers = generateSignals(normalData, vwapData);
//       createSeriesMarkers(candleSeriesRef.current, markers);
//     }

//     const { ut, signals } = calculateUTBotWithSignals(candleData);

//     // ✅ ALWAYS UPDATE LAST SIGNAL
//     if (signals?.length > 0 && setLastUTSignal) {
//       setLastUTSignal(signals[signals.length - 1]);
//     }

//     // =========================
//     // ONLY DISPLAY WHEN UTBOT
//     // =========================

//     if (indicator === "utbot") {
//       // utSeriesRef.current.setData(ut);
//       utSeriesRef.current.setData(normalizeSeriesTime(ut, mode, candleTimes));

//       vwapSeriesRef.current.setData([]);
//       bbUpperRef.current.setData([]);

//       bbMiddleRef.current.setData([]);

//       bbLowerRef.current.setData([]);

//       bbEMARef.current.setData([]);

//       createSeriesMarkers(candleSeriesRef.current, signals);
//     }

//     if (indicator === "bbawe" && bbaweData) {
//       console.log("UPPER BAND", bbaweData.upperBand);
//       console.log("LOWER BAND", bbaweData.lowerBand);
//       // bbUpperRef.current.setData(bbaweData.upperBand || []);

//       // bbMiddleRef.current.setData(bbaweData.middleBand || []);

//       // bbLowerRef.current.setData(bbaweData.lowerBand || []);

//       // bbEMARef.current.setData(bbaweData.ema || []);
//       bbUpperRef.current.setData(
//         normalizeSeriesTime(bbaweData.upperBand, mode, candleTimes),
//       );

//       bbMiddleRef.current.setData(
//         normalizeSeriesTime(bbaweData.middleBand, mode, candleTimes),
//       );

//       bbLowerRef.current.setData(
//         normalizeSeriesTime(bbaweData.lowerBand, mode, candleTimes),
//       );

//       bbEMARef.current.setData(normalizeSeriesTime(bbaweData.ema, mode));

//       // createSeriesMarkers(candleSeriesRef.current, bbaweData.signals || []);
//       // createSeriesMarkers(
//       //   candleSeriesRef.current,
//       //   normalizeSeriesTime(signals, mode, candleTimes),
//       // );
//       createSeriesMarkers(
//         candleSeriesRef.current,
//         normalizeSeriesTime(bbaweData.signals || [], mode, candleTimes),
//       );
//     }

//     //     if (indicator === "macd") {

//     //   vwapSeriesRef.current.setData([]);

//     //   utSeriesRef.current.setData([]);

//     //   bbUpperRef.current.setData([]);

//     //   bbMiddleRef.current.setData([]);

//     //   bbLowerRef.current.setData([]);

//     //   bbEMARef.current.setData([]);

//     //   const macdSignals =
//     //     mode === "min"
//     //       ? generateMACDCrossoverSignals(
//     //           intradayData?.macdData || []
//     //         )
//     //       : generateMACDCrossoverSignals(
//     //           histData?.macdData || []
//     //         );

//     //   createSeriesMarkers(
//     //     candleSeriesRef.current,
//     //     normalizeSeriesTime(
//     //       macdSignals,
//     //       mode,
//     //       candleTimes
//     //     )
//     //   );
//     // }
//     // if (indicator === "bbawe" && bbaweData) {
//     //   bbUpperRef.current.setData(
//     //     (bbaweData.upperBand || []).map((d) => ({
//     //       time: Number(d.time),
//     //       value: d.value,
//     //     })),
//     //   );

//     //   bbMiddleRef.current.setData(
//     //     (bbaweData.middleBand || []).map((d) => ({
//     //       time: Number(d.time),
//     //       value: d.value,
//     //     })),
//     //   );

//     //   bbLowerRef.current.setData(
//     //     (bbaweData.lowerBand || []).map((d) => ({
//     //       time: Number(d.time),
//     //       value: d.value,
//     //     })),
//     //   );

//     //   bbEMARef.current.setData(
//     //     (bbaweData.ema || []).map((d) => ({
//     //       time: Number(d.time),
//     //       value: d.value,
//     //     })),
//     //   );

//     //   createSeriesMarkers(candleSeriesRef.current, bbaweData.signals || []);
//     // }

//     // 🔥 fit chart

//     chartInstance.current.timeScale().fitContent();
//   }, [
//     source,
//     intraday,
//     chartType,
//     vwapSource,
//     indicator,
//     timeframe,
//     mode,
//     bbaweData,
//   ]);

//   useEffect(() => {
//     if (mode === "min") {
//       setTimeframe("1m");
//     } else {
//       setTimeframe("1d");
//     }
//   }, [mode]);

//   //new useffect for resizing
//   // useEffect(() => {
//   //   if (!chartRef.current || !containerRef.current) return;

//   //   chartInstance.current = createChart(chartRef.current, {
//   //     width: containerRef.current.clientWidth,

//   //     layout: {
//   //       background: { color: "#0f172a" },
//   //       textColor: "#d1d5db",
//   //     },
//   //   });

//   //   return () => {
//   //     chartInstance.current.remove();
//   //   };
//   // }, []);
//   // useEffect(() => {
//   //   if (!containerRef.current || !chartInstance.current) return;

//   //   const resizeObserver = new ResizeObserver(() => {
//   //     chartInstance.current.applyOptions({
//   //       width: containerRef.current.clientWidth,
//   //     });
//   //   });

//   //   resizeObserver.observe(containerRef.current);

//   //   return () => {
//   //     resizeObserver.disconnect();
//   //   };
//   // }, [width]);
//   useEffect(() => {
//     if (!containerRef.current || !chartInstance.current) return;

//     let frameId = null;

//     const resizeChart = () => {
//       if (frameId) cancelAnimationFrame(frameId);

//       frameId = requestAnimationFrame(() => {
//         if (!containerRef.current || !chartInstance.current) return;

//         const width = containerRef.current.clientWidth;
//         const height = containerRef.current.clientHeight || 420;

//         chartInstance.current.applyOptions({
//           width,
//           height,
//         });

//         chartInstance.current.timeScale().fitContent();
//       });
//     };

//     resizeChart();

//     const resizeObserver = new ResizeObserver(resizeChart);
//     resizeObserver.observe(containerRef.current);

//     return () => {
//       if (frameId) cancelAnimationFrame(frameId);
//       resizeObserver.disconnect();
//     };
//   }, [isMaximized]);
//   // useEffect(() => {
//   //   if (indicator !== "bbawe") return;

//   //   if (!intradayData?.securityId) return;

//   //   getChartIndicators({
//   //     symbol: intradayData?.companyCode,

//   //     securityId: intradayData?.securityId,

//   //     interval:
//   //       timeframe === "1m"
//   //         ? "1"
//   //         : timeframe === "3m"
//   //           ? "3"
//   //           : timeframe === "5m"
//   //             ? "5"
//   //             : timeframe === "15m"
//   //               ? "15"
//   //               : "5",
//   //   });
//   // }, [indicator, timeframe]);
//   // const calculateUTBot = (candles, key = 3, atrPeriod = 10) => {
//   //   let tr = [];

//   //   for (let i = 1; i < candles.length; i++) {
//   //     const high = candles[i].high;
//   //     const low = candles[i].low;
//   //     const prevClose = candles[i - 1].close;

//   //     tr.push(
//   //       Math.max(
//   //         high - low,
//   //         Math.abs(high - prevClose),
//   //         Math.abs(low - prevClose),
//   //       ),
//   //     );
//   //   }

//   //   let atr = tr.map((_, i) => {
//   //     const slice = tr.slice(Math.max(0, i - atrPeriod), i + 1);
//   //     return slice.reduce((a, b) => a + b, 0) / slice.length;
//   //   });

//   //   let trailing = [];
//   //   let prev = candles[0].close;

//   //   for (let i = 0; i < candles.length; i++) {
//   //     const loss = key * (atr[i] || 0);

//   //     if (candles[i].close > prev) {
//   //       prev = Math.max(prev, candles[i].close - loss);
//   //     } else {
//   //       prev = Math.min(prev, candles[i].close + loss);
//   //     }

//   //     trailing.push({
//   //       time: candles[i].time,
//   //       value: prev,
//   //     });
//   //   }

//   //   return trailing;
//   // };
//   // const calculateUTBot = (candles, key = 3, atrPeriod = 10) => {
//   //   let tr = [];

//   //   for (let i = 1; i < candles.length; i++) {
//   //     const high = candles[i].high;
//   //     const low = candles[i].low;
//   //     const prevClose = candles[i - 1].close;

//   //     tr.push(
//   //       Math.max(
//   //         high - low,
//   //         Math.abs(high - prevClose),
//   //         Math.abs(low - prevClose),
//   //       ),
//   //     );
//   //   }

//   //   let atr = tr.map((_, i) => {
//   //     const slice = tr.slice(Math.max(0, i - atrPeriod), i + 1);
//   //     return slice.reduce((a, b) => a + b, 0) / slice.length;
//   //   });

//   //   let trailing = [];
//   //   let prev = candles[0].close;

//   //   for (let i = 0; i < candles.length; i++) {
//   //     const loss = key * (atr[i] || 0);

//   //     if (candles[i].close > prev) {
//   //       prev = Math.max(prev, candles[i].close - loss);
//   //     } else {
//   //       prev = Math.min(prev, candles[i].close + loss);
//   //     }

//   //     trailing.push({
//   //       time: candles[i].time,
//   //       value: prev,
//   //     });
//   //   }

//   //   return trailing;
//   // };

//   const calculateUTBot = (candles, key = 3, atrPeriod = 10) => {
//     if (!candles || candles.length < 2) return [];

//     const tr = [];

//     // ✅ True Range
//     for (let i = 1; i < candles.length; i++) {
//       const high = candles[i].high;
//       const low = candles[i].low;
//       const prevClose = candles[i - 1].close;

//       tr.push(
//         Math.max(
//           high - low,
//           Math.abs(high - prevClose),
//           Math.abs(low - prevClose),
//         ),
//       );
//     }

//     // ✅ RMA (Wilder ATR like Pine)
//     const atr = [];
//     for (let i = 0; i < tr.length; i++) {
//       if (i === 0) {
//         atr.push(tr[0]);
//       } else {
//         atr.push((atr[i - 1] * (atrPeriod - 1) + tr[i]) / atrPeriod);
//       }
//     }

//     // align ATR
//     atr.unshift(atr[0]);

//     let trailingStop = [];
//     let prevStop = candles[0].close;
//     let prevPos = 0;

//     for (let i = 0; i < candles.length; i++) {
//       const src = candles[i].close;
//       const loss = key * atr[i];

//       let stop;

//       if (i === 0) {
//         stop = src;
//       } else {
//         const prevSrc = candles[i - 1].close;

//         if (src > prevStop && prevSrc > prevStop) {
//           stop = Math.max(prevStop, src - loss);
//         } else if (src < prevStop && prevSrc < prevStop) {
//           stop = Math.min(prevStop, src + loss);
//         } else {
//           stop = src > prevStop ? src - loss : src + loss;
//         }
//       }

//       trailingStop.push({
//         time: candles[i].time,
//         value: stop,
//       });

//       prevStop = stop;
//     }

//     return trailingStop;
//   };
//   // const generateUTSignals = (candles, utData) => {
//   //   const signals = [];

//   //   for (let i = 1; i < candles.length; i++) {
//   //     const prevClose = candles[i - 1].close;
//   //     const currClose = candles[i].close;

//   //     const prevUT = utData[i - 1]?.value;
//   //     const currUT = utData[i]?.value;

//   //     if (!prevUT || !currUT) continue;

//   //     if (prevClose < prevUT && currClose > currUT) {
//   //       signals.push({
//   //         time: candles[i].time,
//   //         position: "belowBar",
//   //         color: "green",
//   //         shape: "arrowUp",
//   //         text: "BUY",
//   //       });
//   //     }

//   //     if (prevClose > prevUT && currClose < currUT) {
//   //       signals.push({
//   //         time: candles[i].time,
//   //         position: "aboveBar",
//   //         color: "red",
//   //         shape: "arrowDown",
//   //         text: "SELL",
//   //       });
//   //     }
//   //   }

//   //   return signals;
//   // };

//   // const generateUTSignals = (candles, utData) => {
//   //   const signals = [];

//   //   for (let i = 1; i < candles.length; i++) {
//   //     const prevClose = candles[i - 1].close;
//   //     const currClose = candles[i].close;

//   //     const prevUT = utData[i - 1]?.value;
//   //     const currUT = utData[i]?.value;

//   //     if (!prevUT || !currUT) continue;

//   //     if (prevClose < prevUT && currClose > currUT) {
//   //       signals.push({
//   //         time: candles[i].time,
//   //         position: "belowBar",
//   //         color: "green",
//   //         shape: "arrowUp",
//   //         text: "BUY",
//   //       });
//   //     }

//   //     if (prevClose > prevUT && currClose < currUT) {
//   //       signals.push({
//   //         time: candles[i].time,
//   //         position: "aboveBar",
//   //         color: "red",
//   //         shape: "arrowDown",
//   //         text: "SELL",
//   //       });
//   //     }
//   //   }

//   //   return signals;
//   // };

//   const generateMACDCrossoverSignals = (data = []) => {
//     if (!Array.isArray(data) || data.length < 2) {
//       return [];
//     }

//     const signals = [];

//     for (let i = 1; i < data.length; i++) {
//       const prev = data[i - 1];
//       const curr = data[i];

//       if (
//         prev?.MACD == null ||
//         prev?.signal == null ||
//         curr?.MACD == null ||
//         curr?.signal == null
//       ) {
//         continue;
//       }

//       // 🔥 BUY CROSSOVER
//       if (prev.MACD < prev.signal && curr.MACD > curr.signal) {
//         signals.push({
//           time: curr.date || curr.time,

//           position: "belowBar",

//           color: "#22c55e",

//           shape: "arrowUp",

//           text: "MACD BUY",
//         });
//       }

//       // 🔥 SELL CROSSOVER
//       else if (prev.MACD > prev.signal && curr.MACD < curr.signal) {
//         signals.push({
//           time: curr.date || curr.time,

//           position: "aboveBar",

//           color: "#ef4444",

//           shape: "arrowDown",

//           text: "MACD SELL",
//         });
//       }
//     }

//     return signals;
//   };
//   const generateUTSignals = (candles, utData) => {
//     const signals = [];

//     let position = 0; // 1 = bullish, -1 = bearish

//     for (let i = 2; i < candles.length - 1; i++) {
//       const prevClose = candles[i - 1].close;
//       const currClose = candles[i].close;

//       const prevUT = utData[i - 1]?.value;
//       const currUT = utData[i]?.value;

//       if (!prevUT || !currUT) continue;

//       // 🔥 BUY (only when switching from bearish)
//       if (prevClose < prevUT && currClose > currUT) {
//         if (position !== 1) {
//           signals.push({
//             time: candles[i].time,
//             position: "belowBar",
//             color: "green",
//             shape: "arrowUp",
//             text: "BUY",
//             signal: "Bullish",
//           });
//           position = 1;
//         }
//       }

//       // 🔥 SELL (only when switching from bullish)
//       else if (prevClose > prevUT && currClose < currUT) {
//         if (position !== -1) {
//           signals.push({
//             time: candles[i].time,
//             position: "aboveBar",
//             color: "red",
//             shape: "arrowDown",
//             text: "SELL",
//             signal: "Bearish",
//           });
//           position = -1;
//         }
//       }
//     }

//     return signals;
//   };

//   const aggregateCandles = (data, interval) => {
//     if (interval === 1) return data;

//     const result = [];

//     for (let i = 0; i < data.length; i += interval) {
//       const chunk = data.slice(i, i + interval);
//       if (!chunk.length) continue;

//       result.push({
//         time: chunk[0].time,
//         open: chunk[0].open,
//         high: Math.max(...chunk.map((c) => c.high)),
//         low: Math.min(...chunk.map((c) => c.low)),
//         close: chunk[chunk.length - 1].close,
//       });
//     }

//     return result;
//   };
//   //   const { ut, signals } =
//   //   calculateUTBotWithSignals(
//   //     candles
//   //   );
//   //   useEffect(() => {

//   //   if (
//   //     signals?.length > 0 &&
//   //     setLastUTSignal
//   //   ) {

//   //     setLastUTSignal(
//   //       signals[
//   //         signals.length - 1
//   //       ]
//   //     );
//   //   }

//   // }, [signals]);
//   return (
//     <>
//       <div
//         style={{
//           marginBottom: "10px",
//           display: "flex",
//           gap: "10px",
//           justifyContent: "flex-end",
//         }}
//       >
//         {/* Candle Toggle */}
//         <div className="candle-toggle">
//           <select
//             className="test-select"
//             style={{
//               background: "inherit",
//               // color: "white",
//               fontWeight: "600",
//               color: "black",
//               // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//               boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//               padding: "5px 7px",
//               borderRadius: "10px",
//             }}
//             value={indicator}
//             onChange={(e) => setIndicator(e.target.value)}
//           >
//             <option value="vwap">VWAP</option>
//             <option value="utbot">UT Bot</option>
//             <option value="bbawe">BBAWE</option>
//           </select>

//           <select
//             className="test-select"
//             style={{
//               background: "inherit",
//               fontWeight: "600",
//               color: "black",
//               boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
//               padding: "5px 7px",
//               borderRadius: "10px",
//             }}
//             value={mode}
//             onChange={(e) => setMode(e.target.value)}
//           >
//             <option value="min">MIN</option>
//             <option value="day">DAY</option>
//           </select>
//         </div>

//         {indicator === "vwap" && (
//           <div className="inner-select-indicator">
//             <select
//               className="test-select"
//               style={{
//                 background: "inherit",
//                 // color: "white",
//                 fontWeight: "600",
//                 color: "black",
//                 // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//                 boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//                 padding: "5px 7px",
//                 borderRadius: "10px",
//               }}
//               value={chartType}
//               onChange={(e) => setChartType(e.target.value)}
//             >
//               <option value="normal">Default</option>
//               <option value="heikin">Heikin Ashi</option>
//             </select>

//             {/* NEW: VWAP Source Toggle */}
//             <select
//               className="test-select"
//               style={{
//                 background: "inherit",
//                 // color: "white",
//                 fontWeight: "600",
//                 color: "black",
//                 // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//                 boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//                 padding: "5px 7px",
//                 borderRadius: "10px",
//               }}
//               value={vwapSource}
//               onChange={(e) => setVwapSource(e.target.value)}
//             >
//               <option value="hlc3">HLC3</option>
//               <option value="close">Close</option>
//               <option value="low">Low</option>
//               <option value="high">High</option>
//             </select>
//           </div>
//         )}
//         {(indicator === "utbot" || indicator === "bbawe") && (
//           <div>
//             {/* <select
//               className="test-select"
//               style={{
//                 background: "inherit",
//                 // color: "white",
//                 fontWeight: "600",
//                 color: "black",
//                 // boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.2)",
//                 boxShadow: " 0 4px 12px rgba(0, 0, 0, 0.4)",
//                 padding: "5px 7px",
//                 borderRadius: "10px",
//               }}
//               value={timeframe}
//               onChange={(e) => setTimeframe(e.target.value)}
//             >
//               <option value="1m">1m</option>
//               <option value="3m">3m</option>
//               <option value="5m">5m</option>
//             </select> */}
//             <select
//               className="test-select"
//               style={{
//                 background: "inherit",
//                 fontWeight: "600",
//                 color: "black",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
//                 padding: "5px 7px",
//                 borderRadius: "10px",
//               }}
//               value={timeframe}
//               onChange={(e) => setTimeframe(e.target.value)}
//             >
//               {mode === "min" ? (
//                 <>
//                   <option value="1m">1m</option>
//                   <option value="3m">3m</option>
//                   <option value="5m">5m</option>
//                   <option value="15m">15m</option>
//                 </>
//               ) : (
//                 <>
//                   <option value="1d">1D</option>
//                   <option value="1w">1W</option>
//                   <option value="1M">1M</option>
//                   <option value="3M">3M</option>
//                 </>
//               )}
//             </select>
//           </div>
//         )}
//       </div>

//       {/* 📊 Chart */}
//       {/* <div
//         // ref={containerRef}
//         style={{ width: "100%" }}
//       >
//         <div ref={chartRef} style={{ width: "100%" }} />
//       </div> */}
//       <div
//         ref={containerRef}
//         className="candle-chart-container"
//         // style={{
//         //   width: "100%",
//         //   height: "100%",
//         // }}
//         style={{
//           width: "100%",
//           height: isMaximized ? "100%" : "420px",
//           minHeight: isMaximized ? "600px" : "420px",
//         }}
//       >
//         <div
//           ref={chartRef}
//           style={{
//             width: "100%",
//             height: "100%",
//           }}
//         />
//       </div>
//     </>
//   );
// };

// export default CandleChart;

// New code

/* ═══════════════════════════════════════════════════════════
   1. TIME — single parser, no index fallback
   ═══════════════════════════════════════════════════════════ */

/* ═══════════════════════════════════════════════════════════
   1. TIME — single parser, no index fallback
   ═══════════════════════════════════════════════════════════ */

const parseTime = (t, mode) => {
  if (!t) return mode === "day" ? "2026-01-01" : Math.floor(Date.now() / 1000);

  if (mode === "day") {
    if (typeof t === "string" && t.includes("-")) return t.split("T")[0];
    if (typeof t === "number")
      return new Date(t * 1000).toISOString().split("T")[0];
    return new Date(t).toISOString().split("T")[0];
  }

  if (typeof t === "number")
    return t > 9_999_999_999 ? Math.floor(t / 1000) : t;
  const ms = new Date(t).getTime();
  return isNaN(ms) ? Math.floor(Date.now() / 1000) : Math.floor(ms / 1000);
};

/* ═══════════════════════════════════════════════════════════
   2. DATA PREP
   ═══════════════════════════════════════════════════════════ */

const prepareCandles = (data, mode) => {
  const { open = [], high = [], low = [], close = [], timestamp = [] } = data;
  return timestamp.map((t, i) => ({
    time: mode === "day" ? t : parseTime(t, mode),
    open: open[i],
    high: high[i],
    low: low[i],
    close: close[i],
  }));
};

const prepareHeikinAshi = (data, mode) => {
  const { open = [], high = [], low = [], close = [], timestamp = [] } = data;
  const ha = [];
  let pO = open[0],
    pC = (open[0] + high[0] + low[0] + close[0]) / 4;

  for (let i = 0; i < timestamp.length; i++) {
    const hC = (open[i] + high[i] + low[i] + close[i]) / 4;
    const hO = (pO + pC) / 2;
    ha.push({
      time: parseTime(timestamp[i], mode),
      open: hO,
      high: Math.max(high[i], hO, hC),
      low: Math.min(low[i], hO, hC),
      close: hC,
    });
    pO = hO;
    pC = hC;
  }
  return ha;
};

const dedupe = (arr, mode) => {
  const seen = new Set();
  return arr
    .filter((d) => {
      const k = String(d.time);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    })
    .sort((a, b) =>
      mode === "day"
        ? new Date(a.time) - new Date(b.time)
        : Number(a.time) - Number(b.time),
    );
};

const aggregate = (data, step) => {
  if (step <= 1) return data;
  const out = [];
  for (let i = 0; i < data.length; i += step) {
    const chunk = data.slice(i, i + step);
    if (!chunk.length) continue;
    out.push({
      time: chunk[0].time,
      open: chunk[0].open,
      high: Math.max(...chunk.map((c) => c.high)),
      low: Math.min(...chunk.map((c) => c.low)),
      close: chunk[chunk.length - 1].close,
    });
  }
  return out;
};

const normTime = (arr, mode, validTimes) => {
  const seen = new Set();
  const out = arr
    .map((d) => ({ ...d, time: parseTime(d.time, mode) }))
    .filter((d) => {
      const k = String(d.time);
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    })
    .sort((a, b) =>
      mode === "day"
        ? new Date(a.time) - new Date(b.time)
        : Number(a.time) - Number(b.time),
    );
  if (mode !== "day" && validTimes) {
    return out.filter((d) => validTimes.has(Number(d.time)));
  }
  return out;
};

/* ═══════════════════════════════════════════════════════════
   3. INDICATORS
   ═══════════════════════════════════════════════════════════ */

// ── EMA helper ──
const ema = (src, period) => {
  const k = 2 / (period + 1);
  const out = [src[0]];
  for (let i = 1; i < src.length; i++)
    out.push(src[i] * k + out[i - 1] * (1 - k));
  return out;
};

// ── Wilder RMA (for ATR) ──
const rma = (src, period) => {
  const out = [src[0]];
  for (let i = 1; i < src.length; i++)
    out.push((out[i - 1] * (period - 1) + src[i]) / period);
  return out;
};

// ── ATR ──
const atr = (candles, period) => {
  const tr = [candles[0].high - candles[0].low];
  for (let i = 1; i < candles.length; i++) {
    const h = candles[i].high,
      l = candles[i].low,
      pc = candles[i - 1].close;
    tr.push(Math.max(h - l, Math.abs(h - pc), Math.abs(l - pc)));
  }
  return rma(tr, period);
};

/* ── VWAP ── */
const calcVWAP = (data, mode, source = "hlc3") => {
  const {
    high = [],
    low = [],
    close = [],
    volume = [],
    timestamp = [],
  } = data || {};
  if (!close.length) return [];
  let cpv = 0,
    cv = 0;
  return timestamp.map((t, i) => {
    let p;
    if (source === "close") p = +close[i];
    else if (source === "high") p = +high[i];
    else if (source === "low") p = +low[i];
    else p = (+high[i] + +low[i] + +close[i]) / 3;
    const v = +volume[i] || 0;
    cpv += p * v;
    cv += v;
    return { time: parseTime(t, mode), value: cv > 0 ? cpv / cv : null };
  });
};

/* ── Bollinger Bands ── */
const calcBB = (candles, period = 20, mult = 2) => {
  if (candles.length < period) return { upper: [], middle: [], lower: [] };
  const upper = [],
    middle = [],
    lower = [];
  for (let i = period - 1; i < candles.length; i++) {
    let sum = 0;
    for (let j = i - period + 1; j <= i; j++) sum += candles[j].close;
    const sma = sum / period;
    let sq = 0;
    for (let j = i - period + 1; j <= i; j++)
      sq += (candles[j].close - sma) ** 2;
    const sd = Math.sqrt(sq / period);
    upper.push({ time: candles[i].time, value: sma + mult * sd });
    middle.push({ time: candles[i].time, value: sma });
    lower.push({ time: candles[i].time, value: sma - mult * sd });
  }
  return { upper, middle, lower };
};

/* ── UT Bot ── */
const calcUTBot = (candles, key = 3, atrPeriod = 10) => {
  if (candles.length < 2) return { line: [], signals: [] };
  const atrVals = atr(candles, atrPeriod);
  const line = [];
  const signals = [];
  let prevStop = candles[0].close;

  // ★ DIRECTION STATE — prevents duplicate signals
  // 1 = bullish, -1 = bearish, 0 = unknown
  let direction = 0;

  for (let i = 0; i < candles.length; i++) {
    const src = candles[i].close;
    const prevSrc = i > 0 ? candles[i - 1].close : src;
    const nLoss = key * atrVals[i];

    let stop;
    if (i === 0) {
      stop = src;
    } else if (src > prevStop && prevSrc > prevStop) {
      stop = Math.max(prevStop, src - nLoss);
    } else if (src < prevStop && prevSrc < prevStop) {
      stop = Math.min(prevStop, src + nLoss);
    } else {
      stop = src > prevStop ? src - nLoss : src + nLoss;
    }

    if (i > 0) {
      const crossUp = prevSrc <= prevStop && src > stop;
      const crossDown = prevSrc >= prevStop && src < stop;

      // ★ Only fire when direction CHANGES
      if (crossUp && direction !== 1) {
        signals.push({
          time: candles[i].time,
          position: "belowBar",
          color: "#22c55e",
          shape: "arrowUp",
          text: "",
          size: 1.5,
        });
        direction = 1;
      }
      if (crossDown && direction !== -1) {
        signals.push({
          time: candles[i].time,
          position: "aboveBar",
          color: "#ef4444",
          shape: "arrowDown",
          text: "",
          size: 1.5,
        });
        direction = -1;
      }
    }
    line.push({ time: candles[i].time, value: stop });
    prevStop = stop;
  }
  return { line, signals };
};

/* ── BB Signals (bounce, not touch) ── */
const calcBBSignals = (candles, bb) => {
  if (!bb.lower.length) return [];
  const map = new Map();
  bb.lower.forEach((d, i) => {
    map.set(String(d.time), {
      lo: d.value,
      hi: bb.upper[i]?.value,
      mid: bb.middle[i]?.value,
    });
  });
  const signals = [];
  let dir = 0; // ★ direction lock

  for (let i = 2; i < candles.length; i++) {
    const curr = map.get(String(candles[i].time));
    const prev = map.get(String(candles[i - 1].time));
    if (!curr || !prev) continue;

    // BUY: close was below lower, now reclaims above it + confirm candle closes green
    if (
      candles[i - 1].close <= prev.lo &&
      candles[i].close > curr.lo &&
      candles[i].close > candles[i].open &&
      dir !== 1
    ) {
      signals.push({
        time: candles[i].time,
        position: "belowBar",
        color: "#22c55e",
        shape: "arrowUp",
        text: "",
        size: 1.5,
      });
      dir = 1;
    }

    // SELL: close was above upper, now drops below it + confirm red candle
    if (
      candles[i - 1].close >= prev.hi &&
      candles[i].close < curr.hi &&
      candles[i].close < candles[i].open &&
      dir !== -1
    ) {
      signals.push({
        time: candles[i].time,
        position: "aboveBar",
        color: "#ef4444",
        shape: "arrowDown",
        text: "",
        size: 1.5,
      });
      dir = -1;
    }
  }
  return signals;
};

/* ── VWAP Signals ── */
const calcVWAPSignals = (candles, vwapData) => {
  const vMap = new Map();
  vwapData.forEach((v) => vMap.set(String(v.time), v.value));
  const signals = [];
  let dir = 0;

  for (let i = 1; i < candles.length; i++) {
    const pv = vMap.get(String(candles[i - 1].time));
    const cv = vMap.get(String(candles[i].time));
    if (!pv || !cv) continue;

    if (candles[i - 1].close < pv && candles[i].close > cv && dir !== 1) {
      signals.push({
        time: candles[i].time,
        position: "belowBar",
        color: "#22c55e",
        shape: "arrowUp",
        text: "",
        size: 1.5,
      });
      dir = 1;
    }
    if (candles[i - 1].close > pv && candles[i].close < cv && dir !== -1) {
      signals.push({
        time: candles[i].time,
        position: "aboveBar",
        color: "#ef4444",
        shape: "arrowDown",
        text: "",
        size: 1.5,
      });
      dir = -1;
    }
  }
  return signals;
};

/* ── MACD (returns line data + crossover markers) ── */
const calcMACD = (candles, fast = 12, slow = 26, sig = 9) => {
  if (candles.length < slow + sig)
    return { macdLine: [], signalLine: [], histogram: [], crossovers: [] };

  const closes = candles.map((c) => c.close);
  const emaF = ema(closes, fast);
  const emaS = ema(closes, slow);
  const macdRaw = emaF.map((v, i) => v - emaS[i]);

  // signal line only after we have enough slow EMA data
  const macdSlice = macdRaw.slice(slow - 1);
  const sigLine = ema(macdSlice, sig);

  const macdLine = [],
    signalLine = [],
    histogram = [],
    crossovers = [];
  const offset = slow - 1;

  let prevDir = 0; // ★ crossover direction lock

  for (let i = 0; i < macdSlice.length; i++) {
    if (i < sig - 1) continue; // wait for signal EMA warmup
    const ci = offset + i; // candle index
    const m = macdSlice[i];
    const s = sigLine[i];
    const h = m - s;

    macdLine.push({ time: candles[ci].time, value: m });
    signalLine.push({ time: candles[ci].time, value: s });
    histogram.push({
      time: candles[ci].time,
      value: h,
      color: h >= 0 ? "#26a69a" : "#ef5350",
    });

    // ★ Crossover detection with direction lock
    if (i >= sig) {
      const prevM = macdSlice[i - 1];
      const prevS = sigLine[i - 1];

      if (prevM <= prevS && m > s && prevDir !== 1) {
        crossovers.push({
          time: candles[ci].time,
          position: "belowBar",
          color: "#22c55e",
          shape: "arrowUp",
          text: "",
          size: 1,
        });
        prevDir = 1;
      }
      if (prevM >= prevS && m < s && prevDir !== -1) {
        crossovers.push({
          time: candles[ci].time,
          position: "aboveBar",
          color: "#ef4444",
          shape: "arrowDown",
          text: "",
          size: 1,
        });
        prevDir = -1;
      }
    }
  }
  return { macdLine, signalLine, histogram, crossovers };
};

/* ═══════════════════════════════════════════════════════════
   4. OHLC TOOLTIP (TradingView top-left overlay)
   ═══════════════════════════════════════════════════════════ */

const makeTooltip = (container) => {
  const el = document.createElement("div");
  el.style.cssText = `
    position:absolute; top:8px; left:12px; z-index:10;
    pointer-events:none;
    font: 600 12px/1.6 -apple-system, BlinkMacSystemFont, 'SF Mono', monospace;
    color:#cbd5e1; background:rgba(15,23,42,0.88);
    padding:4px 10px; border-radius:6px;
    backdrop-filter:blur(4px); white-space:nowrap;
    font-variant-numeric:tabular-nums;
    display:none;
  `;
  container.style.position = "relative";
  container.appendChild(el);
  return el;
};

const updateTooltip = (el, param, series, mode) => {
  if (!param.time || !param.seriesData) {
    el.style.display = "none";
    return;
  }
  const d = param.seriesData.get(series);
  if (!d || d.open == null) {
    el.style.display = "none";
    return;
  }

  const { open: o, high: h, low: l, close: c } = d;
  const chg = c - o,
    pct = ((chg / o) * 100).toFixed(2);
  const col = chg >= 0 ? "#22c55e" : "#ef4444";

  let ts;
  if (mode === "day") {
    const dt =
      typeof param.time === "string"
        ? new Date(param.time)
        : new Date(param.time * 1000);
    ts = dt.toLocaleDateString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } else {
    ts = new Date(param.time * 1000).toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  el.style.display = "block";
  el.innerHTML = [
    `<span style="color:#64748b">${ts}</span>`,
    `O <b>${o.toFixed(2)}</b>`,
    `H <b style="color:#22c55e">${h.toFixed(2)}</b>`,
    `L <b style="color:#ef4444">${l.toFixed(2)}</b>`,
    `C <b style="color:${col}">${c.toFixed(2)}</b>`,
    `<span style="color:${col}">${chg >= 0 ? "+" : ""}${chg.toFixed(2)} (${pct}%)</span>`,
  ].join("&ensp;");
};

/* ═══════════════════════════════════════════════════════════
   5. MACD TOOLTIP (bottom pane)
   ═══════════════════════════════════════════════════════════ */

const makeMACDTooltip = (container) => {
  const el = document.createElement("div");
  el.style.cssText = `
    position:absolute; top:4px; left:12px; z-index:10;
    pointer-events:none;
    font: 600 11px/1.5 -apple-system, BlinkMacSystemFont, monospace;
    color:#94a3b8; background:rgba(15,23,42,0.88);
    padding:3px 8px; border-radius:4px;
    backdrop-filter:blur(4px); white-space:nowrap;
    font-variant-numeric:tabular-nums;
    display:none;
  `;
  container.style.position = "relative";
  container.appendChild(el);
  return el;
};

const updateMACDTooltip = (el, param, macdSeries, sigSeries, histSeries) => {
  if (!param.time || !param.seriesData) {
    el.style.display = "none";
    return;
  }
  const m = param.seriesData.get(macdSeries)?.value;
  const s = param.seriesData.get(sigSeries)?.value;
  const h = param.seriesData.get(histSeries)?.value;
  if (m == null) {
    el.style.display = "none";
    return;
  }

  const hCol = (h || 0) >= 0 ? "#26a69a" : "#ef5350";
  el.style.display = "block";
  el.innerHTML = [
    `<span style="color:#3b82f6">MACD ${m?.toFixed(2) ?? "—"}</span>`,
    `<span style="color:#f59e0b">Signal ${s?.toFixed(2) ?? "—"}</span>`,
    `<span style="color:${hCol}">Hist ${h?.toFixed(2) ?? "—"}</span>`,
  ].join("&ensp;");
};

/* ═══════════════════════════════════════════════════════════
   6. COMPONENT
   ═══════════════════════════════════════════════════════════ */

// const CandleChart = ({
//   intradayData,
//   histData,
//   setLastUTSignal,
//   chartIndicatorData,
//   isMaximized,
//   livePrice,
// }) => {
//   const IST_OFFSET = 5.5 * 60 * 60;
//   // DOM refs
//   const containerRef = useRef(null);
//   const priceRef = useRef(null); // top pane

//   // const macdRef = useRef(null); // bottom pane

//   // chart instances
//   const priceChart = useRef(null);
//   // const macdChart = useRef(null);

//   // series refs — price pane
//   const candleSeries = useRef(null);
//   const overlayLine = useRef(null); // VWAP / UT line
//   const bbUp = useRef(null);
//   const bbMid = useRef(null);
//   const bbLo = useRef(null);
//   // BBAWE (backend)
//   const bwUp = useRef(null);
//   const bwMid = useRef(null);
//   const bwLo = useRef(null);
//   const bwEma = useRef(null);

//   // series refs — MACD pane
//   const mHist = useRef(null);
//   const mLine = useRef(null);
//   const mSig = useRef(null);

//   // tooltip refs
//   const priceTooltip = useRef(null);
//   // const macdTooltip = useRef(null);

//   // sync guard
//   const syncingRef = useRef(false);

//   //new live
//   const lastCandle = useRef(null);

//   // state
//   const [indicator, setIndicator] = useState("vwap");
//   const [chartType, setChartType] = useState("normal");
//   const [vwapSrc, setVwapSrc] = useState("hlc3");
//   const [tf, setTf] = useState("1m");
//   const [mode, setMode] = useState("min");
//   const [bbP, setBbP] = useState(20);
//   const [bbM, setBbM] = useState(2);

//   const bbaweData = chartIndicatorData?.bbawe;
//   const source = mode === "min" ? intradayData?.intraday : histData?.hist;

//   // ─── shared chart config ───
//   const baseOpts = useCallback(
//     (h) => ({
//       width: 100,
//       height: h,
//       layout: { background: { color: "#0f172a" }, textColor: "#94a3b8" },
//       grid: {
//         vertLines: { color: "#1e293b" },
//         horzLines: { color: "#1e293b" },
//       },
//       crosshair: { mode: CrosshairMode.Normal },
//       rightPriceScale: { borderColor: "#334155" },
//       timeScale: {
//         borderColor: "#334155",
//         timeVisible: mode !== "day",
//         secondsVisible: false,
//         tickMarkFormatter: (time) => {
//           if (mode === "day")
//             return new Date(time).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//             });
//           return new Date(time * 1000).toLocaleTimeString("en-IN", {
//             hour: "2-digit",
//             minute: "2-digit",
//             hour12: true,
//             timeZone: "Asia/Kolkata",
//           });
//         },
//       },
//       localization: {
//         timeFormatter: (time) => {
//           if (mode === "day")
//             return new Date(time).toLocaleDateString("en-IN", {
//               day: "numeric",
//               month: "short",
//             });
//           return new Date(Number(time) * 1000).toLocaleString("en-IN", {
//             timeZone: "Asia/Kolkata",
//             day: "numeric",
//             month: "short",
//             hour: "2-digit",
//             minute: "2-digit",
//             hour12: true,
//           });
//         },
//       },
//     }),
//     [mode],
//   );

//   /* ═══════════════════════════════════════════════════
//      CREATE / DESTROY CHARTS
//      ═══════════════════════════════════════════════════ */

//   useEffect(() => {
//     // if (!priceRef.current || !macdRef.current) return;
//     if (!priceRef.current) return;
//     const w = containerRef.current?.clientWidth || 800;
//     const priceH = isMaximized ? 480 : 340;

//     // ── Price chart ──
//     const pc = createChart(priceRef.current, { ...baseOpts(priceH), width: w });
//     priceChart.current = pc;

//     candleSeries.current = pc.addSeries(CandlestickSeries, {
//       upColor: "#22c55e",
//       downColor: "#ef4444",
//       borderUpColor: "#22c55e",
//       borderDownColor: "#ef4444",
//       wickUpColor: "#22c55e",
//       wickDownColor: "#ef4444",
//     });

//     overlayLine.current = pc.addSeries(LineSeries, {
//       color: "#f59e0b",
//       lineWidth: 2,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bbUp.current = pc.addSeries(LineSeries, {
//       color: "#60a5fa",
//       lineWidth: 1,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bbMid.current = pc.addSeries(LineSeries, {
//       color: "#f97316",
//       lineWidth: 1,
//       lineStyle: 2,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bbLo.current = pc.addSeries(LineSeries, {
//       color: "#60a5fa",
//       lineWidth: 1,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });

//     bwUp.current = pc.addSeries(LineSeries, {
//       color: "#60a5fa",
//       lineWidth: 1,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bwMid.current = pc.addSeries(LineSeries, {
//       color: "#ef4444",
//       lineWidth: 2,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bwLo.current = pc.addSeries(LineSeries, {
//       color: "#60a5fa",
//       lineWidth: 1,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     bwEma.current = pc.addSeries(LineSeries, {
//       color: "#22c55e",
//       lineWidth: 2,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });

//     // OHLC tooltip
//     priceTooltip.current = makeTooltip(priceRef.current);

//     // ── MACD chart ──
//     // const mc = createChart(macdRef.current, { ...baseOpts(150), width: w });
//     // macdChart.current = mc;

//     mHist.current = pc.addSeries(HistogramSeries, {
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     mLine.current = pc.addSeries(LineSeries, {
//       color: "#3b82f6",
//       lineWidth: 2,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });
//     mSig.current = pc.addSeries(LineSeries, {
//       color: "#f59e0b",
//       lineWidth: 1,
//       priceLineVisible: false,
//       lastValueVisible: false,
//     });

//     pc.priceScale("macd").applyOptions({
//   scaleMargins: { top: 0.7, bottom: 0.02 },
//   borderColor: "#334155",
//   drawTicks: false,
// });

// pc.priceScale("right").applyOptions({
//   scaleMargins: { top: 0.02, bottom: 0.32 },
// });

//     // MACD tooltip
//     // macdTooltip.current = makeMACDTooltip(macdRef.current);

//     /* ─── SYNC: time scale ─── */
//     pc.timeScale().subscribeVisibleLogicalRangeChange((range) => {
//       if (syncingRef.current || !range) return;
//       syncingRef.current = true;
//       mc.timeScale().setVisibleLogicalRange(range);
//       syncingRef.current = false;
//     });
//     mc.timeScale().subscribeVisibleLogicalRangeChange((range) => {
//       if (syncingRef.current || !range) return;
//       syncingRef.current = true;
//       pc.timeScale().setVisibleLogicalRange(range);
//       syncingRef.current = false;
//     });

//     /* ─── SYNC: crosshair ─── */
//     pc.subscribeCrosshairMove((param) => {
//       updateTooltip(priceTooltip.current, param, candleSeries.current, mode);

//       if (syncingRef.current) return; // prevent infinite loop
//       syncingRef.current = true;

//       if (param.time && mHist.current) {
//         try {
//           mc.setCrosshairPosition(NaN, param.time, mHist.current);
//         } catch {
//           // time doesn't exist in MACD data — ignore silently
//           mc.clearCrosshairPosition();
//         }
//       } else {
//         mc.clearCrosshairPosition();
//       }

//       syncingRef.current = false;
//     });

//     mc.subscribeCrosshairMove((param) => {
//       updateMACDTooltip(
//         macdTooltip.current,
//         param,
//         mLine.current,
//         mSig.current,
//         mHist.current,
//       );

//       if (syncingRef.current) return; // prevent infinite loop
//       syncingRef.current = true;

//       if (param.time && candleSeries.current) {
//         try {
//           pc.setCrosshairPosition(NaN, param.time, candleSeries.current);
//         } catch {
//           // time doesn't exist in price data — ignore silently
//           pc.clearCrosshairPosition();
//         }
//       } else {
//         pc.clearCrosshairPosition();
//       }

//       syncingRef.current = false;
//     });

//     mc.subscribeCrosshairMove((param) => {
//       // update MACD tooltip
//       updateMACDTooltip(
//         macdTooltip.current,
//         param,
//         mLine.current,
//         mSig.current,
//         mHist.current,
//       );

//       // sync crosshair to price
//       if (param.time && candleSeries.current) {
//         pc.setCrosshairPosition(NaN, param.time, candleSeries.current);
//       }
//       if (!param.time) pc.clearCrosshairPosition();
//     });

//     return () => {
//       pc.remove();
//       mc.remove();
//     };
//   }, [mode, isMaximized]);

//   /* ═══════════════════════════════════════════════════
//      UPDATE DATA
//      ═══════════════════════════════════════════════════ */

//   useEffect(() => {
//     if (!source || !candleSeries.current) return;

//     // ── build source ──
//     const raw =
//       mode === "min"
//         ? { ...source, timestamp: intradayData?.intraday?.timestamp }
//         : { ...source, timestamp: histData?.dates };

//     const normal = dedupe(prepareCandles(raw, mode), mode);
//     const haData =
//       chartType === "heikin"
//         ? dedupe(prepareHeikinAshi(raw, mode), mode)
//         : null;

//     const step =
//       mode === "min"
//         ? { "1m": 1, "3m": 3, "5m": 5, "15m": 15 }[tf] || 1
//         : { "1d": 1, "1w": 5, "1M": 20, "3M": 60 }[tf] || 1;

//     const candles = aggregate(haData || normal, step);
//     const times = new Set(candles.map((c) => Number(c.time)));

//     // ── set candles ──
//     candleSeries.current.setData(candles);
//     lastCandle.current = candles.length
//       ? { ...candles[candles.length - 1] }
//       : null;

//     // ── clear overlays ──
//     [overlayLine, bbUp, bbMid, bbLo, bwUp, bwMid, bwLo, bwEma].forEach((r) =>
//       r.current?.setData([]),
//     );
//     createSeriesMarkers(candleSeries.current, []);

//     // ── MACD always in bottom pane (uses non-heikin data for accuracy) ──
//     const macd = calcMACD(aggregate(normal, step));
//     mHist.current?.setData(normTime(macd.histogram, mode, times));
//     mLine.current?.setData(normTime(macd.macdLine, mode, times));
//     mSig.current?.setData(normTime(macd.signalLine, mode, times));

//     // MACD crossover markers on the MACD histogram series
//     createSeriesMarkers(mHist.current, normTime(macd.crossovers, mode, times));

//     // ── TOP PANE INDICATOR ──
//     let priceSignals = [];

//     if (indicator === "vwap") {
//       const vwap = calcVWAP(raw, mode, vwapSrc);
//       overlayLine.current.setData(normTime(vwap, mode, times));
//       overlayLine.current.applyOptions({ color: "#f59e0b" });
//       priceSignals = calcVWAPSignals(candles, normTime(vwap, mode, times));
//     }

//     if (indicator === "utbot") {
//       const { line, signals } = calcUTBot(candles);
//       overlayLine.current.setData(normTime(line, mode, times));
//       overlayLine.current.applyOptions({ color: "#a855f7" });
//       priceSignals = signals;
//       if (signals.length && setLastUTSignal) setLastUTSignal(signals.at(-1));
//     }

//     if (indicator === "bb") {
//       const bb = calcBB(candles, bbP, bbM);
//       bbUp.current.setData(normTime(bb.upper, mode, times));
//       bbMid.current.setData(normTime(bb.middle, mode, times));
//       bbLo.current.setData(normTime(bb.lower, mode, times));
//       priceSignals = calcBBSignals(candles, bb);
//     }

//     if (indicator === "bbawe" && bbaweData) {
//       bwUp.current.setData(normTime(bbaweData.upperBand || [], mode, times));
//       bwMid.current.setData(normTime(bbaweData.middleBand || [], mode, times));
//       bwLo.current.setData(normTime(bbaweData.lowerBand || [], mode, times));
//       bwEma.current.setData(normTime(bbaweData.ema || [], mode));
//       priceSignals = normTime(bbaweData.signals || [], mode, times);
//     }

//     createSeriesMarkers(candleSeries.current, priceSignals);

//     priceChart.current?.timeScale().fitContent();
//     macdChart.current?.timeScale().fitContent();
//   }, [
//     source,
//     intradayData?.intraday,
//     chartType,
//     vwapSrc,
//     indicator,
//     tf,
//     mode,
//     bbaweData,
//     bbP,
//     bbM,
//   ]);

//   // ─── reset timeframe on mode switch ───
//   useEffect(() => {
//     setTf(mode === "min" ? "1m" : "1d");
//   }, [mode]);

//   //liveprice
//   useEffect(() => {
//     if (
//       !livePrice ||
//       !candleSeries.current ||
//       !lastCandle.current ||
//       mode !== "min"
//     )
//       return;

//     const prev = lastCandle.current;
//     const updated = {
//       time: prev.time,
//       open: prev.open,
//       high: Math.max(prev.high, livePrice),
//       low: Math.min(prev.low, livePrice),
//       close: livePrice,
//     };

//     const nowUtcSec = Math.floor(Date.now() / 1000);
//     const nowIstSec = nowUtcSec + IST_OFFSET;
//     const currentMinute = Math.floor(nowIstSec / 60) * 60;
//     console.log("CANDLE DEBUG:", {
//       prevTime: prev.time,
//       prevDate: new Date(prev.time * 1000).toLocaleString("en-IN", {
//         timeZone: "Asia/Kolkata",
//       }),
//       currentMinute,
//       currentDate: new Date(currentMinute * 1000).toLocaleString("en-IN", {
//         timeZone: "Asia/Kolkata",
//       }),

//       livePrice,
//     });
//     try {
//       candleSeries.current.update(updated);
//       lastCandle.current = updated;
//     } catch {
//       // WebSocket failed or chart not ready — existing snapshot stays
//     }
//   }, [livePrice, mode]);

//   // ─── resize ───
//   useEffect(() => {
//     if (!containerRef.current) return;
//     let raf = null;
//     const resize = () => {
//       if (raf) cancelAnimationFrame(raf);
//       raf = requestAnimationFrame(() => {
//         const w = containerRef.current?.clientWidth;
//         if (!w) return;
//         priceChart.current?.applyOptions({ width: w });
//         macdChart.current?.applyOptions({ width: w });
//         priceChart.current?.timeScale().fitContent();
//         macdChart.current?.timeScale().fitContent();
//       });
//     };
//     resize();
//     const obs = new ResizeObserver(resize);
//     obs.observe(containerRef.current);
//     return () => {
//       if (raf) cancelAnimationFrame(raf);
//       obs.disconnect();
//     };
//   }, [isMaximized]);

//   /* ═══════════════════════════════════════════════════
//      RENDER
//      ═══════════════════════════════════════════════════ */

//   return (
//     <>
//       {/* ─── Controls ─── */}
//       <div className="candle-controls">
//         <select
//           value={indicator}
//           onChange={(e) => setIndicator(e.target.value)}
//           className="candle-select"
//         >
//           <option value="vwap">VWAP</option>
//           <option value="utbot">UT Bot</option>
//           <option value="bb">Bollinger Band</option>
//           <option value="bbawe">BBAWE</option>
//         </select>

//         <select
//           value={mode}
//           onChange={(e) => setMode(e.target.value)}
//           className="candle-select"
//         >
//           <option value="min">Intraday</option>
//           <option value="day">Daily</option>
//         </select>

//         <select
//           value={tf}
//           onChange={(e) => setTf(e.target.value)}
//           className="candle-select"
//         >
//           {mode === "min" ? (
//             <>
//               {["1m", "3m", "5m", "15m"].map((v) => (
//                 <option key={v} value={v}>
//                   {v}
//                 </option>
//               ))}
//             </>
//           ) : (
//             <>
//               {["1d", "1w", "1M", "3M"].map((v) => (
//                 <option key={v} value={v}>
//                   {v.toUpperCase()}
//                 </option>
//               ))}
//             </>
//           )}
//         </select>

//         <select
//           value={chartType}
//           onChange={(e) => setChartType(e.target.value)}
//           className="candle-select"
//         >
//           <option value="normal">Candles</option>
//           <option value="heikin">Heikin Ashi</option>
//         </select>

//         {indicator === "vwap" && (
//           <select
//             value={vwapSrc}
//             onChange={(e) => setVwapSrc(e.target.value)}
//             className="candle-select"
//           >
//             {["hlc3", "close", "low", "high"].map((v) => (
//               <option key={v} value={v}>
//                 {v.toUpperCase()}
//               </option>
//             ))}
//           </select>
//         )}

//         {indicator === "bb" && (
//           <>
//             <select
//               value={bbP}
//               onChange={(e) => setBbP(+e.target.value)}
//               className="candle-select"
//             >
//               {[10, 20, 50].map((v) => (
//                 <option key={v} value={v}>
//                   BB {v}
//                 </option>
//               ))}
//             </select>
//             <select
//               value={bbM}
//               onChange={(e) => setBbM(+e.target.value)}
//               className="candle-select"
//             >
//               {[1.5, 2, 2.5, 3].map((v) => (
//                 <option key={v} value={v}>
//                   {v}σ
//                 </option>
//               ))}
//             </select>
//           </>
//         )}
//       </div>

//       {/* ─── Chart ─── */}
//       <div
//         ref={containerRef}
//         className="candle-chart-container"
//         style={{
//           width: "100%",
//           height: isMaximized ? "100%" : "540px",
//           minHeight: isMaximized ? "700px" : "540px",
//         }}
//       >
//         {/* TOP: Price + indicator overlay */}
//         <div
//           ref={priceRef}
//           style={{ width: "100%", height: "calc(100% - 155px)" }}
//         />

//         {/* Divider */}
//         <div style={{ height: "1px", background: "#334155" }} />

//         {/* BOTTOM: MACD crossover pane */}
//         <div ref={macdRef} style={{ width: "100%", height: "150px" }} />
//       </div>

//       {/* ─── Legend ─── */}
//       <div className="candle-legend">
//         <span className="candle-legend-item">
//           <span className="candle-dot" style={{ background: "#3b82f6" }} /> MACD
//         </span>
//         <span className="candle-legend-item">
//           <span className="candle-dot" style={{ background: "#f59e0b" }} />{" "}
//           Signal
//         </span>
//         <span className="candle-legend-item">
//           <span className="candle-dot" style={{ background: "#26a69a" }} />{" "}
//           Hist+
//         </span>
//         <span className="candle-legend-item">
//           <span className="candle-dot" style={{ background: "#ef5350" }} />{" "}
//           Hist−
//         </span>
//         <span className="candle-legend-item">
//           <span style={{ color: "#22c55e", fontSize: 14, lineHeight: 1 }}>
//             ▲
//           </span>{" "}
//           Bullish
//         </span>
//         <span className="candle-legend-item">
//           <span style={{ color: "#ef4444", fontSize: 14, lineHeight: 1 }}>
//             ▼
//           </span>{" "}
//           Bearish
//         </span>
//       </div>
//     </>
//   );
// };

const CandleChart = ({
  intradayData,
  // indicatorData,
  histData,
  setLastUTSignal,
  chartIndicatorData,
  isMaximized,
  livePrice,
}) => {
  // console.log("InidcatorData", indicatorData);
  console.log("histdata", histData);
  // DOM refs
  const containerRef = useRef(null);
  const priceRef = useRef(null);

  // chart instance (single)
  const priceChart = useRef(null);

  // series refs — price pane
  const candleSeries = useRef(null);
  const overlayLine = useRef(null);
  const bbUp = useRef(null);
  const bbMid = useRef(null);
  const bbLo = useRef(null);
  const bwUp = useRef(null);
  const bwMid = useRef(null);
  const bwLo = useRef(null);
  const bwEma = useRef(null);

  // series refs — MACD (same chart, different scale)
  const mHist = useRef(null);
  const mLine = useRef(null);
  const mSig = useRef(null);

  // tooltip ref
  const priceTooltip = useRef(null);

  // live candle tracking
  const lastCandle = useRef(null);

  // state
  const [indicator, setIndicator] = useState("vwap");
  const [chartType, setChartType] = useState("normal");
  const [vwapSrc, setVwapSrc] = useState("hlc3");
  const [tf, setTf] = useState("1m");
  const [mode, setMode] = useState("min");
  const [bbP, setBbP] = useState(20);
  const [bbM, setBbM] = useState(2);

  const bbaweData = chartIndicatorData?.bbawe;
  const source = mode === "min" ? intradayData?.intraday : histData?.hist_data;

  // ─── shared chart config ───
  const baseOpts = useCallback(
    (h) => ({
      width: 100,
      height: h,
      layout: { background: { color: "#0f172a" }, textColor: "#94a3b8" },
      grid: {
        vertLines: { color: "#1e293b" },
        horzLines: { color: "#1e293b" },
      },
      crosshair: { mode: CrosshairMode.Normal },
      rightPriceScale: { borderColor: "#334155" },
      timeScale: {
        borderColor: "#334155",
        timeVisible: mode !== "day",
        secondsVisible: false,
        tickMarkFormatter: (time) => {
          if (mode === "day")
            return new Date(time).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "short",
            });
          return new Date(time * 1000).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
            timeZone: "Asia/Kolkata",
          });
        },
      },
      localization: {
        timeFormatter: (time) => {
          if (mode === "day")
            return new Date(time).toLocaleDateString("en-IN", {
              day: "numeric",
              month: "short",
            });
          return new Date(Number(time) * 1000).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "numeric",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        },
      },
    }),
    [mode],
  );

  /* ═══════════════════════════════════════════════════
     CREATE / DESTROY CHART (single instance)
     ═══════════════════════════════════════════════════ */
  useEffect(() => {
    if (!priceRef.current) return;
    const w = containerRef.current?.clientWidth || 800;
    // const chartH = isMaximized ? 600 : 500;
    const chartH = isMaximized ? window.innerHeight - 150 : 500;

    const pc = createChart(priceRef.current, { ...baseOpts(chartH), width: w });
    priceChart.current = pc;

    // ── Candle series (right price scale) ──
    candleSeries.current = pc.addSeries(CandlestickSeries, {
      upColor: "#22c55e",
      downColor: "#ef4444",
      borderUpColor: "#22c55e",
      borderDownColor: "#ef4444",
      wickUpColor: "#22c55e",
      wickDownColor: "#ef4444",
    });

    // ── Overlay lines (VWAP, BB etc — right scale) ──
    overlayLine.current = pc.addSeries(LineSeries, {
      color: "#f59e0b",
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bbUp.current = pc.addSeries(LineSeries, {
      color: "#60a5fa",
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bbMid.current = pc.addSeries(LineSeries, {
      color: "#f97316",
      lineWidth: 1,
      lineStyle: 2,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bbLo.current = pc.addSeries(LineSeries, {
      color: "#60a5fa",
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bwUp.current = pc.addSeries(LineSeries, {
      color: "#60a5fa",
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bwMid.current = pc.addSeries(LineSeries, {
      color: "#ef4444",
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bwLo.current = pc.addSeries(LineSeries, {
      color: "#60a5fa",
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: false,
    });
    bwEma.current = pc.addSeries(LineSeries, {
      color: "#22c55e",
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: false,
    });

    // ── MACD series (left "macd" price scale) ──
    mHist.current = pc.addSeries(HistogramSeries, {
      priceLineVisible: false,
      lastValueVisible: false,
      priceScaleId: "macd",
    });
    mLine.current = pc.addSeries(LineSeries, {
      color: "#3b82f6",
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: false,
      priceScaleId: "macd",
    });
    mSig.current = pc.addSeries(LineSeries, {
      color: "#f59e0b",
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: false,
      priceScaleId: "macd",
    });

    // ── Scale layout: price top 68%, MACD bottom 30% ──
    pc.priceScale("macd").applyOptions({
      scaleMargins: { top: 0.7, bottom: 0.02 },
      borderColor: "#334155",
      drawTicks: false,
    });
    pc.priceScale("right").applyOptions({
      scaleMargins: { top: 0.02, bottom: 0.32 },
    });

    // ── Tooltip ──
    priceTooltip.current = makeTooltip(priceRef.current);

    pc.subscribeCrosshairMove((param) => {
      updateTooltip(priceTooltip.current, param, candleSeries.current, mode);
    });

    return () => {
      pc.remove();
    };
  }, [mode]);

  /* ═══════════════════════════════════════════════════
     UPDATE DATA
     ═══════════════════════════════════════════════════ */
  useEffect(() => {
    if (!source || !candleSeries.current) return;

    const raw =
      mode === "min"
        ? { ...source, timestamp: intradayData?.intraday?.timestamp }
        : { ...source, timestamp: histData?.dates };

    const normal = dedupe(prepareCandles(raw, mode), mode);
    const haData =
      chartType === "heikin"
        ? dedupe(prepareHeikinAshi(raw, mode), mode)
        : null;

    const step =
      mode === "min"
        ? { "1m": 1, "3m": 3, "5m": 5, "15m": 15 }[tf] || 1
        : { "1d": 1, "1w": 5, "1M": 20, "3M": 60 }[tf] || 1;

    const candles = aggregate(haData || normal, step);
    const times = new Set(candles.map((c) => Number(c.time)));

    // Set candles + save last for live updates
    candleSeries.current.setData(candles);
    lastCandle.current = candles.length
      ? { ...candles[candles.length - 1] }
      : null;

    // Clear overlays
    [overlayLine, bbUp, bbMid, bbLo, bwUp, bwMid, bwLo, bwEma].forEach((r) =>
      r.current?.setData([]),
    );
    createSeriesMarkers(candleSeries.current, []);

    // MACD
    const macd = calcMACD(aggregate(normal, step));
    mHist.current?.setData(normTime(macd.histogram, mode, times));
    mLine.current?.setData(normTime(macd.macdLine, mode, times));
    mSig.current?.setData(normTime(macd.signalLine, mode, times));
    createSeriesMarkers(mHist.current, normTime(macd.crossovers, mode, times));

    // Indicator overlay
    let priceSignals = [];

    if (indicator === "vwap") {
      const vwap = calcVWAP(raw, mode, vwapSrc);
      overlayLine.current.setData(normTime(vwap, mode, times));
      overlayLine.current.applyOptions({ color: "#f59e0b" });
      priceSignals = calcVWAPSignals(candles, normTime(vwap, mode, times));
    }

    if (indicator === "utbot") {
      const { line, signals } = calcUTBot(candles);
      overlayLine.current.setData(normTime(line, mode, times));
      overlayLine.current.applyOptions({ color: "#a855f7" });
      priceSignals = signals;
      if (signals.length && setLastUTSignal) setLastUTSignal(signals.at(-1));
    }

    if (indicator === "bb") {
      const bb = calcBB(candles, bbP, bbM);
      bbUp.current.setData(normTime(bb.upper, mode, times));
      bbMid.current.setData(normTime(bb.middle, mode, times));
      bbLo.current.setData(normTime(bb.lower, mode, times));
      priceSignals = calcBBSignals(candles, bb);
    }

    if (indicator === "bbawe" && bbaweData) {
      bwUp.current.setData(normTime(bbaweData.upperBand || [], mode, times));
      bwMid.current.setData(normTime(bbaweData.middleBand || [], mode, times));
      bwLo.current.setData(normTime(bbaweData.lowerBand || [], mode, times));
      bwEma.current.setData(normTime(bbaweData.ema || [], mode));
      priceSignals = normTime(bbaweData.signals || [], mode, times);
    }

    createSeriesMarkers(candleSeries.current, priceSignals);
    priceChart.current?.timeScale().fitContent();
  }, [
    source,
    intradayData?.intraday,
    chartType,
    vwapSrc,
    indicator,
    tf,
    mode,
    bbaweData,
    bbP,
    bbM,
  ]);

  // ─── Reset timeframe on mode switch ───
  useEffect(() => {
    setTf(mode === "min" ? "1m" : "1d");
  }, [mode]);

  /* ═══════════════════════════════════════════════════
     LIVE PRICE — update last candle via WebSocket
     ═══════════════════════════════════════════════════ */
  // useEffect(() => {
  //   if (
  //     !livePrice ||
  //     !candleSeries.current ||
  //     !lastCandle.current ||
  //     mode !== "min"
  //   )
  //     return;

  //   const prev = lastCandle.current;

  //   const nowUtcSec = Math.floor(Date.now() / 1000);
  //   const nowIstSec = nowUtcSec + IST_OFFSET;
  //   const currentMinute = Math.floor(nowIstSec / 60) * 60;

  //   const isNewCandle = currentMinute > prev.time;

  //   let updated;

  //   if (isNewCandle) {
  //     updated = {
  //       time: currentMinute,
  //       open: livePrice,
  //       high: livePrice,
  //       low: livePrice,
  //       close: livePrice,
  //     };
  //   } else {
  //     updated = {
  //       time: prev.time,
  //       open: prev.open,
  //       high: Math.max(prev.high, livePrice),
  //       low: Math.min(prev.low, livePrice),
  //       close: livePrice,
  //     };
  //   }

  //   try {
  //     candleSeries.current.update(updated);
  //     lastCandle.current = updated;
  //   } catch {
  //     // Chart not ready — existing snapshot stays
  //   }
  // }, [livePrice, mode]);

  // ─── Resize ───

  useEffect(() => {
    if (
      !livePrice ||
      !candleSeries.current ||
      !lastCandle.current ||
      mode !== "min"
    )
      return;

    const prev = lastCandle.current;

    // Just update the last candle — keep its timestamp
    const updated = {
      time: prev.time,
      open: prev.open,
      high: Math.max(prev.high, livePrice),
      low: Math.min(prev.low, livePrice),
      close: livePrice,
    };

    try {
      candleSeries.current.update(updated);
      lastCandle.current = updated;
    } catch {
      // Chart not ready — existing snapshot stays
    }
  }, [livePrice, mode]);
  // useEffect(() => {
  //   if (!containerRef.current) return;
  //   let raf = null;
  //   const resize = () => {
  //     if (raf) cancelAnimationFrame(raf);
  //     raf = requestAnimationFrame(() => {
  //       const w = containerRef.current?.clientWidth;
  //       if (!w) return;
  //       priceChart.current?.applyOptions({ width: w });
  //       priceChart.current?.timeScale().fitContent();
  //     });
  //   };
  //   resize();
  //   const obs = new ResizeObserver(resize);
  //   obs.observe(containerRef.current);
  //   return () => {
  //     if (raf) cancelAnimationFrame(raf);
  //     obs.disconnect();
  //   };
  // }, [isMaximized]);
  useEffect(() => {
    const container = containerRef.current;

    if (!container || !priceChart.current) return;

    let rafId = null;

    const resizeChart = () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      rafId = requestAnimationFrame(() => {
        if (!containerRef.current || !priceChart.current) return;

        const width = containerRef.current.clientWidth;
        const height = isMaximized ? window.innerHeight - 150 : 500;

        if (width <= 0 || height <= 0) return;

        priceChart.current.applyOptions({
          width,
          height,
        });
      });
    };

    resizeChart();

    const resizeObserver = new ResizeObserver(resizeChart);
    resizeObserver.observe(container);

    window.addEventListener("resize", resizeChart);

    return () => {
      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      resizeObserver.disconnect();
      window.removeEventListener("resize", resizeChart);
    };
  }, [isMaximized]);
  /* ═══════════════════════════════════════════════════
     RENDER
     ═══════════════════════════════════════════════════ */
  return (
    <>
      {/* ─── Controls ─── */}
      <div className="candle-controls">
        <select
          value={indicator}
          onChange={(e) => setIndicator(e.target.value)}
          className="candle-select"
        >
          <option value="vwap">VWAP</option>
          <option value="utbot">UT Bot</option>
          <option value="bb">Bollinger Band</option>
          <option value="bbawe">BBAWE</option>
        </select>

        <select
          value={mode}
          onChange={(e) => setMode(e.target.value)}
          className="candle-select"
        >
          <option value="min">Intraday</option>
          <option value="day">Daily</option>
        </select>

        <select
          value={tf}
          onChange={(e) => setTf(e.target.value)}
          className="candle-select"
        >
          {mode === "min" ? (
            <>
              {["1m", "3m", "5m", "15m"].map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </>
          ) : (
            <>
              {["1d", "1w", "1M", "3M"].map((v) => (
                <option key={v} value={v}>
                  {v.toUpperCase()}
                </option>
              ))}
            </>
          )}
        </select>

        <select
          value={chartType}
          onChange={(e) => setChartType(e.target.value)}
          className="candle-select"
        >
          <option value="normal">Candles</option>
          <option value="heikin">Heikin Ashi</option>
        </select>

        {indicator === "vwap" && (
          <select
            value={vwapSrc}
            onChange={(e) => setVwapSrc(e.target.value)}
            className="candle-select"
          >
            {["hlc3", "close", "low", "high"].map((v) => (
              <option key={v} value={v}>
                {v.toUpperCase()}
              </option>
            ))}
          </select>
        )}

        {indicator === "bb" && (
          <>
            <select
              value={bbP}
              onChange={(e) => setBbP(+e.target.value)}
              className="candle-select"
            >
              {[10, 20, 50].map((v) => (
                <option key={v} value={v}>
                  BB {v}
                </option>
              ))}
            </select>
            <select
              value={bbM}
              onChange={(e) => setBbM(+e.target.value)}
              className="candle-select"
            >
              {[1.5, 2, 2.5, 3].map((v) => (
                <option key={v} value={v}>
                  {v}σ
                </option>
              ))}
            </select>
          </>
        )}
      </div>

      {/* ─── Single Combined Chart ─── */}
      {/* <div
        ref={containerRef}
        className="candle-chart-container"
        style={{
          width: "100%",
          // height: isMaximized ? "100%" : "500px",
          height: isMaximized ? "calc(100vh - 120px)" : "500px",
          // minHeight: isMaximized ? "700px" : "500px",
        }}
      > */}
      <div
        ref={containerRef}
        className="candle-chart-container"
        style={{
          width: "100%",
          height: isMaximized ? "calc(100vh - 150px)" : "500px",
        }}
      >
        <div ref={priceRef} style={{ width: "100%", height: "100%" }} />
      </div>

      {/* ─── Legend ─── */}
      <div className="candle-legend">
        <span className="candle-legend-item">
          <span className="candle-dot" style={{ background: "#3b82f6" }} /> MACD
        </span>
        <span className="candle-legend-item">
          <span className="candle-dot" style={{ background: "#f59e0b" }} />{" "}
          Signal
        </span>
        <span className="candle-legend-item">
          <span className="candle-dot" style={{ background: "#26a69a" }} />{" "}
          Hist+
        </span>
        <span className="candle-legend-item">
          <span className="candle-dot" style={{ background: "#ef5350" }} />{" "}
          Hist−
        </span>
        <span className="candle-legend-item">
          <span style={{ color: "#22c55e", fontSize: 14, lineHeight: 1 }}>
            ▲
          </span>{" "}
          Bullish
        </span>
        <span className="candle-legend-item">
          <span style={{ color: "#ef4444", fontSize: 14, lineHeight: 1 }}>
            ▼
          </span>{" "}
          Bearish
        </span>
      </div>
    </>
  );
};
export default CandleChart;
